<!--
  //app/components/Shared/icons/FeaturedPlayerLightningIcon.vue
  -->

<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  circleColor?: string;
  iconColor?: string;
};

withDefaults(defineProps<Props>(), {
  height: 15,
  width: 15,
  iconColor: "black",
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="circleColor"
  >
    <rect width="20" height="20" rx="10" fill="currentColor" />
    <path
      d="M11.1637 5L6.57162 10.2728C6.53478 10.3115 6.51094 10.3593 6.50296 10.4102C6.49498 10.4611 6.50322 10.5131 6.52667 10.5598C6.55012 10.6065 6.58778 10.6459 6.63511 10.6734C6.68244 10.7009 6.7374 10.7151 6.79335 10.7145H8.83627V15L13.4284 9.72719C13.4652 9.68846 13.4891 9.64075 13.497 9.58983C13.505 9.53891 13.4968 9.48695 13.4733 9.44024C13.4499 9.39353 13.4122 9.35406 13.3649 9.3266C13.3176 9.29915 13.2626 9.28488 13.2066 9.28552H11.1637V5Z"
      :fill="iconColor"
    />
  </svg>
</template>

<style scoped></style>
